/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useNavigate } from 'react-router';

import { useAppDispatch, useAppSelector } from 'src/store';

import * as urlFor from 'src/shared/helpers/urlHelper';

import {
  getSelectedSpecies,
  getVepFormParameters,
  getVepFormInputText,
  getVepFormInputFileName,
  getVepFormInputCommittedFlag
} from 'src/content/app/tools/vep/state/vep-form/vepFormSelectors';

import { onVepFormSubmission } from 'src/content/app/tools/vep/state/vep-form/vepFormSlice';

import { PrimaryButton } from 'src/shared/components/button/Button';

const VepSubmitButton = (props: { className?: string }) => {
  const selectedSpecies = useAppSelector(getSelectedSpecies);
  const inputText = useAppSelector(getVepFormInputText);
  const inputFileName = useAppSelector(getVepFormInputFileName);
  const formParameters = useAppSelector(getVepFormParameters);
  const isInputCommitted = useAppSelector(getVepFormInputCommittedFlag);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const canSubmit = Boolean(
    selectedSpecies &&
    (inputText || inputFileName) &&
    Object.keys(formParameters).length &&
    isInputCommitted
  );

  const onSubmit = async () => {
    await dispatch(onVepFormSubmission());
    navigate(urlFor.vepSubmissionsList());
  };

  return (
    <PrimaryButton
      disabled={!canSubmit}
      onClick={onSubmit}
      className={props.className}
    >
      Run
    </PrimaryButton>
  );
};

export default VepSubmitButton;
